/* BIZIBOIZ Corteiz-type shop — cart, filters, product sheet */
(() => {
  const root = document.querySelector(".ftw-shop");
  if (!root) return;

  const moneyFormat = root.dataset.moneyFormat || "{{amount}}";
  const isLocal = location.hostname === "127.0.0.1" || location.hostname === "localhost";

  const $ = (sel, el = document) => el.querySelector(sel);
  const $$ = (sel, el = document) => [...el.querySelectorAll(sel)];

  let selectedVariantId = null;
  let sheetOpen = false;
  let sheetVariants = [];
  let sheetOptionDefs = [];
  let sheetSelectedOptions = [];
  let sheetImages = [];
  let sheetImageIndex = 0;
  let sheetAvailable = true;

  const shopDocumentTitle = root.dataset.ftwProduct
    ? root.dataset.shopTitle || "BIZIBOIZ"
    : document.title;

  function productPath(url) {
    if (!url || url === "#") return "";
    try {
      const u = new URL(url, location.origin);
      if (!/\/products\/[^/]+/.test(u.pathname)) return "";
      return u.pathname + u.search;
    } catch (_) {
      return "";
    }
  }

  function productHandleFromPath(path) {
    const match = String(path || location.pathname).match(/\/products\/([^/?#]+)/);
    if (!match) return "";
    try {
      return decodeURIComponent(match[1]);
    } catch (_) {
      return match[1];
    }
  }

  function shopPath() {
    const home = root.dataset.homeUrl || "/";
    try {
      const u = new URL(home, location.origin);
      return u.pathname + u.search;
    } catch (_) {
      return "/";
    }
  }

  function landingData() {
    const el = document.getElementById("ftw-landing-product");
    if (!el) return null;
    try {
      const data = JSON.parse(el.textContent);
      return data && data.handle ? data : null;
    } catch (_) {
      return null;
    }
  }

  function cardFromLanding(data) {
    const card = document.createElement("a");
    card.dataset.product = data.handle || "";
    card.dataset.title = data.title || "";
    card.dataset.price = data.price || "";
    card.dataset.image = data.image || "";
    card.dataset.description = data.description || "";
    card.dataset.available = data.available ? "1" : "0";
    card.dataset.variantId = data.variantId || "";
    card.dataset.url = data.url || "";
    card.dataset.variants = JSON.stringify(data.variants || []);
    card.dataset.images = JSON.stringify(data.images || []);
    card.dataset.options = JSON.stringify(data.options || []);
    return card;
  }

  function findProductCard(handle) {
    if (!handle) return null;
    return $$(".ftw-product", root).find((card) => card.dataset.product === handle) || null;
  }

  function cardForHandle(handle) {
    const card = findProductCard(handle);
    if (card) return card;
    const landing = landingData();
    if (landing && landing.handle === handle) return cardFromLanding(landing);
    return null;
  }

  function sheetDescription(card) {
    const landing = landingData();
    if (
      landing &&
      landing.handle &&
      landing.handle === card.dataset.product &&
      landing.description
    ) {
      return landing.description;
    }
    return card.dataset.description || "";
  }

  const THEME_KEY = "ftw-theme";

  function getTheme() {
    const t = document.documentElement.getAttribute("data-ftw-theme");
    return t === "dark" ? "dark" : "light";
  }

  function syncThemeButton(theme) {
    const isDark = theme === "dark";
    $$("[data-ftw-theme]", root).forEach((btn) => {
      btn.setAttribute("aria-pressed", isDark ? "true" : "false");
      btn.setAttribute("aria-label", isDark ? "Switch to light mode" : "Switch to dark mode");
      if (!btn.querySelector("svg")) {
        btn.textContent = isDark ? "LIGHT MODE" : "DARK MODE";
      }
    });
  }

  function setTheme(theme) {
    const next = theme === "dark" ? "dark" : "light";
    document.documentElement.setAttribute("data-ftw-theme", next);
    try {
      localStorage.setItem(THEME_KEY, next);
    } catch (_) {}
    syncThemeButton(next);
  }

  syncThemeButton(getTheme());

  function toast(msg) {
    const el = $("#toast");
    if (!el) return;
    $("#toast-body").textContent = msg;
    el.classList.add("is-on");
    clearTimeout(toast._t);
    toast._t = setTimeout(() => el.classList.remove("is-on"), 2200);
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(cents, moneyFormat);
    }
    return (Number(cents) / 100).toFixed(0) + " Kč";
  }

  function updateTrayCart(count) {
    const el = $("#cart-count");
    if (el) el.textContent = String(count ?? 0);
  }

  async function fetchCart() {
    const res = await fetch("/cart.js", { headers: { Accept: "application/json" } });
    return res.json();
  }

  async function changeCartLine(key, quantity) {
    if (!key) return false;
    const qty = Math.max(0, Number(quantity) || 0);

    if (isLocal) {
      toast(qty === 0 ? "REMOVED." : "CART UPDATED.");
      return true;
    }

    try {
      const res = await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity: qty }),
      });
      if (!res.ok) throw new Error("change failed");
      await renderCart();
      if (qty === 0) toast("REMOVED.");
      return true;
    } catch {
      toast("COULDN'T UPDATE CART.");
      return false;
    }
  }

  function cartImageUrl(item) {
    const raw =
      item?.image ||
      item?.featured_image?.url ||
      item?.featured_image ||
      "";
    if (!raw || typeof raw !== "string") return "";
    if (raw.startsWith("//")) return `https:${raw}`;
    return raw;
  }

  function escapeHtml(s) {
    return String(s || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  const UPSELL_COLLECTION_RE =
    /(^|[\s,/|-])(accessories?|hats?|caps?|beanies?|t-shirts?|tees?|tee)([\s,/|-]|$)/i;

  function isUpsellAllowed(product) {
    const blob = [product.collections, product.handle, product.title].filter(Boolean).join(" ");
    return UPSELL_COLLECTION_RE.test(blob);
  }

  function getUpsellPool() {
    const raw = $("#ftw-upsell-data")?.textContent;
    if (raw) {
      try {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed) && parsed.length) {
          return parsed.filter((p) => p && p.variantId && isUpsellAllowed(p));
        }
      } catch (_) {}
    }
    return $$(".ftw-product", root)
      .filter((card) => card.dataset.available !== "0")
      .map((card) => ({
        id: Number(card.dataset.productId) || 0,
        handle: card.dataset.product || "",
        title: card.dataset.title || "",
        price: card.dataset.price || "",
        image: card.dataset.image || "",
        collections: card.dataset.collections || "",
        variantId: Number(card.dataset.variantId),
        available: true,
      }))
      .filter((p) => p.variantId && isUpsellAllowed(p));
  }

  function renderUpsell(cart) {
    const host = $("#cart-upsell");
    if (!host) return;
    const limit = Math.max(1, Number(root.dataset.upsellLimit || 2));
    const heading = (root.dataset.upsellHeading || "ADD THIS TOO").toUpperCase();
    const inCartIds = new Set((cart.items || []).map((i) => Number(i.product_id)));
    const inCartHandles = new Set((cart.items || []).map((i) => i.handle).filter(Boolean));
    const picks = getUpsellPool()
      .filter((p) => {
        if (p.available === false) return false;
        if (p.id && inCartIds.has(Number(p.id))) return false;
        if (p.handle && inCartHandles.has(p.handle)) return false;
        return true;
      })
      .slice(0, limit);

    if (!picks.length) {
      host.hidden = true;
      host.innerHTML = "";
      return;
    }

    host.hidden = false;
    host.innerHTML = `
      <div class="ftw-upsell__head">${escapeHtml(heading)}</div>
      <div class="ftw-upsell__list">
        ${picks
          .map(
            (p) => `<div class="ftw-upsell__item">
            <div class="ftw-upsell__media">
              ${
                p.image
                  ? `<img src="${escapeHtml(p.image)}" alt="" width="56" height="56" loading="lazy">`
                  : ""
              }
            </div>
            <div class="ftw-upsell__meta">
              <div class="ftw-upsell__title">${escapeHtml(p.title)}</div>
              <div class="ftw-upsell__price">${escapeHtml(p.price)}</div>
            </div>
            <button type="button" class="ftw-upsell__add" data-upsell-add="${p.variantId}">+</button>
          </div>`
          )
          .join("")}
      </div>`;
  }

  const FREE_SHIP_CZK = Math.max(
    1,
    Number(root.dataset.freeShippingCzk || 4000) || 4000
  );
  const FREE_SHIP_CENTS = FREE_SHIP_CZK * 100;

  function cartSubtotal(cart) {
    const n = Number(cart?.items_subtotal_price ?? cart?.total_price ?? 0);
    return Number.isFinite(n) ? Math.max(0, n) : 0;
  }

  function renderShippingProgress(cart) {
    const host = $("#cart-shipping");
    if (!host) return;
    const spent = cartSubtotal(cart);
    const pct = Math.min(100, Math.round((spent / FREE_SHIP_CENTS) * 100));
    const unlocked = spent >= FREE_SHIP_CENTS;
    const left = Math.max(0, FREE_SHIP_CENTS - spent);
    const msg = unlocked
      ? "FREE CZ SHIPPING UNLOCKED."
      : spent > 0
        ? `${formatMoney(left)} AWAY FROM FREE SHIPPING`
        : `FREE CZ SHIPPING FROM ${FREE_SHIP_CZK.toLocaleString("cs-CZ")} KČ`;

    host.hidden = false;
    host.classList.toggle("is-unlocked", unlocked);
    host.innerHTML = `
      <div class="ftw-ship__label">${escapeHtml(msg)}</div>
      <div
        class="ftw-ship__track"
        role="progressbar"
        aria-valuemin="0"
        aria-valuemax="100"
        aria-valuenow="${pct}"
        aria-label="Free shipping progress"
      >
        <span class="ftw-ship__fill" style="transform: scaleX(${pct / 100})"></span>
      </div>
      <div class="ftw-ship__meta">
        <span>${formatMoney(spent)}</span>
        <span>${FREE_SHIP_CZK.toLocaleString("cs-CZ")} KČ</span>
      </div>`;
  }

  function renderCartFooter(cart) {
    const footer = $("#cart-footer");
    if (!footer) return;
    const empty = !cart?.item_count;
    footer.hidden = false;
    footer.innerHTML = `
      <strong>${empty ? "TOTAL: —" : `TOTAL: ${formatMoney(cart.total_price)}`}</strong>
      <button type="button" class="ftw-btn" id="ftw-outfit-open">OUTFIT CHECKER</button>
      ${
        empty
          ? `<button type="button" class="ftw-btn ftw-btn--primary" disabled aria-disabled="true">CHECKOUT</button>`
          : `<a class="ftw-btn ftw-btn--primary" href="/checkout">CHECKOUT</a>`
      }`;
  }

  async function renderCart() {
    const body = $("#cart-body");
    const upsell = $("#cart-upsell");
    if (!body) return;
    try {
      const cart = await fetchCart();
      updateTrayCart(cart.item_count);
      renderShippingProgress(cart);
      if (!cart.item_count) {
        body.innerHTML = `<div class="ftw-empty">CART EMPTY.</div>`;
        if (upsell) {
          upsell.hidden = true;
          upsell.innerHTML = "";
        }
        renderCartFooter(cart);
        return;
      }
      const lines = cart.items
        .map((i) => {
          const title = escapeHtml(i.product_title || i.title || "Item");
          const variant =
            i.variant_title && i.variant_title !== "Default Title"
              ? ` — ${escapeHtml(i.variant_title)}`
              : "";
          const img = cartImageUrl(i);
          const media = img
            ? `<img src="${escapeHtml(img)}" alt="" width="64" height="64" loading="lazy">`
            : "";
          const key = escapeHtml(i.key || String(i.id));
          const qty = Number(i.quantity) || 1;
          return `<div class="ftw-cart-line" data-cart-key="${key}">
            <div class="ftw-cart-line__media">${media}</div>
            <div class="ftw-cart-line__meta">
              <div class="ftw-cart-line__title">${title}${variant}</div>
              <div class="ftw-cart-line__controls">
                <div class="ftw-cart-qty" role="group" aria-label="Quantity">
                  <button type="button" class="ftw-cart-qty__btn" data-cart-qty="${qty - 1}" data-cart-key="${key}" aria-label="Decrease quantity">−</button>
                  <span class="ftw-cart-qty__val">${qty}</span>
                  <button type="button" class="ftw-cart-qty__btn" data-cart-qty="${qty + 1}" data-cart-key="${key}" aria-label="Increase quantity">+</button>
                </div>
                <button type="button" class="ftw-cart-line__remove" data-cart-qty="0" data-cart-key="${key}">REMOVE</button>
              </div>
            </div>
            <div class="ftw-cart-line__price">${formatMoney(i.final_line_price)}</div>
          </div>`;
        })
        .join("");
      body.innerHTML = `<div class="ftw-cart-lines">${lines}</div>`;
      renderUpsell(cart);
      renderCartFooter(cart);
    } catch {
      body.innerHTML = `<div class="ftw-empty">Couldn't load cart.</div>`;
      if (upsell) {
        upsell.hidden = true;
        upsell.innerHTML = "";
      }
      renderShippingProgress({ item_count: 0, items_subtotal_price: 0, total_price: 0 });
      renderCartFooter({ item_count: 0 });
    }
  }

  function openDrawer(id) {
    closeSheet(true);
    setNavOpen(false);
    $$(".ftw-drawer", root).forEach((d) => {
      d.hidden = d.id !== id;
    });
    $("#ftw-bag-btn")?.setAttribute("aria-expanded", String(id === "ftw-bag"));
    $$("#ftw-account-top-btn, [data-ftw-account]", root).forEach((btn) => {
      btn.setAttribute("aria-expanded", String(id === "ftw-account"));
    });
    if (id === "ftw-bag") renderCart();
  }

  function closeDrawers() {
    $$(".ftw-drawer", root).forEach((d) => {
      d.hidden = true;
    });
    $("#ftw-bag-btn")?.setAttribute("aria-expanded", "false");
    $$("#ftw-account-top-btn, [data-ftw-account]", root).forEach((btn) => {
      btn.setAttribute("aria-expanded", "false");
    });
  }

  function toggleAccountDrawer() {
    const account = $("#ftw-account");
    if (account?.hidden) openDrawer("ftw-account");
    else closeDrawers();
  }

  const OUTFIT_SLOTS = ["head", "top", "bottom"];
  const OUTFIT_SLOT_LAYOUT = {
    head: { x: 0.5, y: 0.1, scale: 0.72 },
    top: { x: 0.5, y: 0.34, scale: 1 },
    bottom: { x: 0.5, y: 0.62, scale: 1.05 },
  };

  function outfitFrames(stage) {
    const stageW = stage?.clientWidth || 800;
    const stageH = stage?.clientHeight || 700;
    const col = Math.round(Math.min(480, Math.max(230, Math.min(stageW, stageH) * 0.42)));
    const headW = Math.round(col * 0.42);
    const headH = Math.round(col * 0.36);
    const topW = col;
    const topH = Math.round(col * 1.08);
    const botW = Math.round(col * 0.9);
    const botH = Math.round(col * 0.78);
    const stack = headH * 0.35 + topH * 0.7 + botH * 0.55;
    const start = Math.max(12, (stageH - stack) / 2);
    const cx = stageW / 2;
    const topTop = start + headH * 0.22;
    return {
      head: { width: headW, height: headH, left: cx - headW / 2, top: start + headH * 0.08 },
      top: { width: topW, height: topH, left: cx - topW / 2, top: topTop },
      bottom: { width: botW, height: botH, left: cx - botW / 2, top: topTop + topH * 0.58 },
    };
  }

  function fitContainedImage(img, target = 0.94) {
    const box = img.parentElement;
    if (!box || !img.naturalWidth || !img.naturalHeight) return;
    const boxW = box.clientWidth;
    const boxH = box.clientHeight;
    if (!boxW || !boxH) return;
    const bounds = productContentBounds(img);
    if (!bounds) return;
    const imgRatio = img.naturalWidth / img.naturalHeight;
    const boxRatio = boxW / boxH;
    const drawW = imgRatio > boxRatio ? boxW : boxH * imgRatio;
    const drawH = imgRatio > boxRatio ? boxW / imgRatio : boxH;
    const scale = Math.min(
      2.6,
      Math.max(0.85, Math.min((boxW * target) / (drawW * bounds.w), (boxH * target) / (drawH * bounds.h)))
    );
    img.style.transform = `scale(${scale})`;
  }
  let outfitDefaults = [];
  let outfitPieceId = 0;
  let outfitDrag = null;
  let outfitSelected = null;
  let outfitSeeded = false;

  function inferOutfitSlot(collections, title) {
    const blob = `${collections || ""} ${title || ""}`.toLowerCase();
    if (/(^|[\s,-])(hat|hats|cap|caps|beanie|beanies|headwear)([\s,-]|$)/.test(blob)) return "head";
    if (/(bottom|bottoms|pant|pants|short|shorts|trouser|jeans|track|skirt|bikini)/.test(blob)) return "bottom";
    if (/(jacket|jackets|hoodie|hoodies|sweat|tee|t-shirt|tshirt|shirt|top|crew|longsleeve|shell|coat)/.test(blob)) {
      return "top";
    }
    return "top";
  }

  function colorOptionIndex(options) {
    return options.findIndex((o) => /^(color|colour|barva|farbe|couleur)$/i.test(String(o?.name || "").trim()));
  }

  function collectOutfitPieces() {
    const seen = new Set();
    const seenImages = new Set();
    const pieces = [];

    const push = (title, image, idHint, collections, price, variantId) => {
      if (!image) return;
      if (seenImages.has(image)) return;
      const key = `${title}::${image}`;
      if (seen.has(key)) return;
      seen.add(key);
      seenImages.add(image);
      pieces.push({
        id: String(idHint || key),
        title: title || "Piece",
        image,
        price: price || "",
        variantId: variantId ? String(variantId) : "",
        slot: inferOutfitSlot(collections, title),
      });
    };

    $$(".ftw-cart-line", root).forEach((line) => {
      const img = line.querySelector("img")?.src;
      const title = line.querySelector(".ftw-cart-line__title")?.textContent?.trim();
      const price = line.querySelector(".ftw-cart-line__price")?.textContent?.trim() || "";
      const variantId = line.dataset.variantId || "";
      push(title, img, `cart-${title}`, "", price, variantId);
    });

    $$(".ftw-product", root).forEach((card) => {
      if (card.dataset.available === "0") return;
      const collections = card.dataset.collections || "";
      const baseTitle = card.dataset.title || "Piece";
      const handle = card.dataset.product || baseTitle;
      const basePrice = card.dataset.price || "";
      const options = parseVariants(card.dataset.options);
      const variants = parseVariants(card.dataset.variants);
      const colorIdx = colorOptionIndex(options);
      let added = 0;

      variants.forEach((v) => {
        if (!v?.image) return;
        const color = colorIdx >= 0 ? v.options?.[colorIdx] : null;
        const title = color ? `${baseTitle} — ${String(color).toUpperCase()}` : baseTitle;
        push(title, v.image, `${handle}-${color || v.id}`, collections, v.price || basePrice, v.id);
        added += 1;
      });

      if (added) return;

      const gallery = parseImages(card.dataset.images, card.dataset.outfitImage || "");
      if (gallery.length === 1) {
        push(baseTitle, gallery[0], handle, collections, basePrice, card.dataset.variantId);
      }
    });

    return pieces.slice(0, 36);
  }

  function pickOutfitDefaults(pieces) {
    const defaults = [];
    OUTFIT_SLOTS.forEach((slot) => {
      const piece = pieces.find((p) => p.slot === slot);
      if (piece) defaults.push({ ...piece, slot });
    });
    if (!defaults.some((p) => p.slot === "top") && pieces[0]) {
      defaults.push({ ...pieces[0], slot: "top" });
    }
    if (!defaults.some((p) => p.slot === "bottom")) {
      const fallback = pieces.find((p) => !defaults.some((d) => d.id === p.id));
      if (fallback) defaults.push({ ...fallback, slot: "bottom" });
    }
    return defaults;
  }

  function syncOutfitHint() {
    const hint = $("#ftw-outfit-hint");
    const layer = $("#ftw-outfit-layer");
    if (!hint || !layer) return;
    hint.hidden = !!layer.querySelector(".ftw-outfit__piece");
  }

  function syncOutfitRackActive() {
    const worn = new Set(
      $$(".ftw-outfit__piece", root).map((el) => el.dataset.outfitSrc).filter(Boolean)
    );
    $$(".ftw-outfit__rack-item", root).forEach((btn) => {
      btn.classList.toggle("is-worn", worn.has(btn.dataset.outfitSrc));
    });
  }

  function renderOutfitBag() {
    const bag = $("#ftw-outfit-bag");
    if (!bag) return;
    const pieces = $$(".ftw-outfit__piece", root);
    if (!pieces.length) {
      bag.innerHTML = `<p class="ftw-outfit__empty">CLICK A PIECE TO BUILD THE FIT.</p>`;
      return;
    }

    const seen = new Set();
    const rows = [];
    pieces.forEach((piece) => {
      const key = piece.dataset.variantId || piece.dataset.outfitSrc || piece.dataset.pieceId;
      if (!key || seen.has(key)) return;
      seen.add(key);
      rows.push(piece);
    });

    bag.innerHTML = rows
      .map((piece) => {
        const title = piece.dataset.outfitTitle || "Piece";
        const price = piece.dataset.outfitPrice || "";
        const src = piece.dataset.outfitSrc || "";
        const variantId = piece.dataset.variantId || "";
        const canAdd = Boolean(variantId);
        return `<article class="ftw-outfit__bag-item">
          <img src="${escapeHtml(src)}" alt="" width="72" height="72" loading="lazy">
          <div class="ftw-outfit__bag-meta">
            <div class="ftw-outfit__bag-title">${escapeHtml(title)}</div>
            ${price ? `<div class="ftw-outfit__bag-price">${escapeHtml(price)}</div>` : ""}
            <button
              type="button"
              class="ftw-outfit__bag-add"
              data-outfit-add="${escapeHtml(variantId)}"
              ${canAdd ? "" : "disabled"}
            >${canAdd ? "ADD TO CART" : "UNAVAILABLE"}</button>
          </div>
        </article>`;
      })
      .join("");
  }

  function syncOutfitLists() {
    syncOutfitHint();
    syncOutfitRackActive();
    renderOutfitBag();
  }

  function selectOutfitPiece(piece) {
    $$(".ftw-outfit__piece", root).forEach((el) => el.classList.remove("is-selected"));
    outfitSelected = piece || null;
    if (piece) piece.classList.add("is-selected");
  }

  function setOutfitPieceScale(piece, scale) {
    if (!piece) return;
    const next = Math.min(1.8, Math.max(0.4, scale));
    piece.dataset.scale = String(next);
    piece.style.setProperty("--outfit-scale", String(next));
  }

  function bindOutfitImage(img, src) {
    const fit = () => fitContainedImage(img, 0.94);
    img.crossOrigin = "anonymous";
    img.alt = img.alt || "";
    img.style.transform = "";
    if (img.getAttribute("src") === src && img.complete && img.naturalWidth) {
      fit();
      return;
    }
    img.addEventListener("load", fit, { once: true });
    img.src = src;
  }

  function placeOutfitPiece(meta, frame) {
    const layer = $("#ftw-outfit-layer");
    const stage = $("#ftw-outfit-stage");
    const src = meta?.image || meta?.src;
    if (!layer || !stage || !src) return null;
    const slot = meta.slot || "top";
    const box = frame || outfitFrames(stage)[slot] || outfitFrames(stage).top;

    const piece = document.createElement("div");
    piece.className = "ftw-outfit__piece";
    piece.dataset.pieceId = String(++outfitPieceId);
    piece.dataset.outfitId = meta.id || src;
    piece.dataset.outfitSrc = src;
    piece.dataset.outfitTitle = meta.title || "Piece";
    piece.dataset.outfitPrice = meta.price || "";
    piece.dataset.variantId = meta.variantId ? String(meta.variantId) : "";
    piece.dataset.slot = slot;
    piece.style.width = `${box.width}px`;
    piece.style.height = `${box.height}px`;
    piece.style.left = `${box.left}px`;
    piece.style.top = `${box.top}px`;
    setOutfitPieceScale(piece, 1);
    piece.innerHTML = `
      <button type="button" class="ftw-outfit__piece-resize" aria-label="Drag to resize">
        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M8 4H4v4M16 4h4v4M8 20H4v-4M16 20h4v-4" stroke="currentColor" stroke-width="1.8" stroke-linecap="square"/>
          <path d="M7 7l10 10M17 7L7 17" stroke="currentColor" stroke-width="1.8" stroke-linecap="square"/>
        </svg>
      </button>
      <img alt="${escapeHtml(meta.title || "")}" draggable="false">
      <button type="button" class="ftw-outfit__piece-kill" aria-label="Remove piece">×</button>`;
    layer.appendChild(piece);
    const img = piece.querySelector("img");
    if (img) bindOutfitImage(img, src);
    selectOutfitPiece(piece);
    syncOutfitLists();
    return piece;
  }

  function wearOutfitPiece(meta) {
    const layer = $("#ftw-outfit-layer");
    const stage = $("#ftw-outfit-stage");
    const src = meta?.image || meta?.src;
    if (!layer || !stage || !src) return null;
    const slot = meta.slot || "top";
    const existing = layer.querySelector(`.ftw-outfit__piece[data-slot="${slot}"]`);
    if (!existing) return placeOutfitPiece(meta, outfitFrames(stage)[slot]);

    existing.dataset.outfitId = meta.id || src;
    existing.dataset.outfitSrc = src;
    existing.dataset.outfitTitle = meta.title || "Piece";
    existing.dataset.outfitPrice = meta.price || "";
    existing.dataset.variantId = meta.variantId ? String(meta.variantId) : "";
    const img = existing.querySelector("img");
    if (img) {
      img.alt = meta.title || "";
      bindOutfitImage(img, src);
    }
    selectOutfitPiece(existing);
    syncOutfitLists();
    return existing;
  }

  function clearOutfitLayer() {
    const layer = $("#ftw-outfit-layer");
    if (layer) layer.innerHTML = "";
    outfitSelected = null;
    syncOutfitLists();
  }

  function seedDefaultOutfit() {
    clearOutfitLayer();
    ["bottom", "top", "head"].forEach((slot) => {
      const piece = outfitDefaults.find((p) => p.slot === slot);
      if (piece) wearOutfitPiece(piece);
    });
    selectOutfitPiece($(".ftw-outfit__piece[data-slot='top']", root) || $(".ftw-outfit__piece", root));
    outfitSeeded = true;
  }

  function buildOutfitRack() {
    const rack = $("#ftw-outfit-rack");
    if (!rack) return;
    const pieces = collectOutfitPieces();
    outfitDefaults = pickOutfitDefaults(pieces);
    if (!pieces.length) {
      rack.innerHTML = `<p class="ftw-outfit__empty">ADD PIECES TO CART OR BROWSE THE DROP.</p>`;
      if (!outfitSeeded) clearOutfitLayer();
      return;
    }
    rack.innerHTML = pieces
      .map(
        (p) => `<button type="button" class="ftw-outfit__rack-item" data-outfit-id="${escapeHtml(p.id)}" data-outfit-src="${escapeHtml(p.image)}" data-outfit-title="${escapeHtml(p.title)}" data-outfit-price="${escapeHtml(p.price || "")}" data-outfit-variant="${escapeHtml(p.variantId || "")}" data-outfit-slot="${escapeHtml(p.slot)}" aria-label="Swap in ${escapeHtml(p.title)}">
          <img src="${escapeHtml(p.image)}" alt="" width="72" height="72" draggable="false" loading="lazy">
          <span>${escapeHtml(p.title)}</span>
        </button>`
      )
      .join("");
    syncOutfitRackActive();
  }

  function resetOutfitStage() {
    seedDefaultOutfit();
  }

  function openOutfitChecker() {
    if (window.matchMedia("(max-width: 720px)").matches) return;
    const outfit = $("#ftw-outfit");
    if (!outfit) return;
    closeSheet(true);
    closeDrawers();
    setNavOpen(false);
    buildOutfitRack();
    outfit.hidden = false;
    document.body.classList.add("ftw-outfit-open");
    requestAnimationFrame(() => {
      outfit.classList.add("is-open");
      if (!outfitSeeded || !$("#ftw-outfit-layer")?.querySelector(".ftw-outfit__piece")) {
        seedDefaultOutfit();
      } else {
        syncOutfitLists();
      }
      $("#ftw-outfit-close")?.focus();
    });
  }

  function closeOutfitChecker() {
    const outfit = $("#ftw-outfit");
    if (!outfit || outfit.hidden) return;
    outfit.classList.remove("is-open");
    document.body.classList.remove("ftw-outfit-open");
    outfitDrag = null;
    setTimeout(() => {
      outfit.hidden = true;
    }, 200);
  }

  function startOutfitDrag(e, mode, payload) {
    if (e.button != null && e.button !== 0) return;
    outfitDrag = {
      mode,
      ...payload,
      pointerId: e.pointerId,
      startX: e.clientX,
      startY: e.clientY,
      moved: false,
    };
    try {
      e.currentTarget.setPointerCapture?.(e.pointerId);
    } catch (_) {}
  }

  function onOutfitPointerMove(e) {
    if (!outfitDrag || e.pointerId !== outfitDrag.pointerId) return;
    const dx = e.clientX - outfitDrag.startX;
    const dy = e.clientY - outfitDrag.startY;
    if (Math.abs(dx) > 3 || Math.abs(dy) > 3) outfitDrag.moved = true;

    if (outfitDrag.mode === "move" && outfitDrag.el) {
      const stage = $("#ftw-outfit-stage");
      if (!stage) return;
      const rect = stage.getBoundingClientRect();
      const el = outfitDrag.el;
      const scale = Number(el.dataset.scale || 1);
      const baseW = el.offsetWidth || 120;
      const baseH = el.offsetHeight || 120;
      const overflowX = Math.max(0, (baseW * (scale - 1)) / 2);
      const overflowY = Math.max(0, (baseH * (scale - 1)) / 2);
      let left = outfitDrag.originLeft + (e.clientX - outfitDrag.startX);
      let top = outfitDrag.originTop + (e.clientY - outfitDrag.startY);
      left = Math.min(Math.max(left, -overflowX), rect.width - baseW + overflowX);
      top = Math.min(Math.max(top, -overflowY), rect.height - baseH + overflowY);
      el.style.left = `${left}px`;
      el.style.top = `${top}px`;
      return;
    }

    if (outfitDrag.mode === "resize" && outfitDrag.el) {
      const dist = Math.hypot(e.clientX - outfitDrag.cx, e.clientY - outfitDrag.cy);
      const ratio = outfitDrag.startDist > 8 ? dist / outfitDrag.startDist : 1;
      setOutfitPieceScale(outfitDrag.el, outfitDrag.startScale * ratio);
    }
  }

  function onOutfitPointerUp(e) {
    if (!outfitDrag || e.pointerId !== outfitDrag.pointerId) return;
    const drag = outfitDrag;
    outfitDrag = null;

    if (drag.mode === "rack") return;

    if (drag.mode === "move" && drag.el && !drag.moved) {
      selectOutfitPiece(drag.el);
    }
  }

  function setTab(id) {
    $$("[data-ftw-tab]", root).forEach((tab) => {
      tab.classList.toggle("is-active", tab.dataset.ftwTab === id);
    });
    $$("[data-ftw-panel]", root).forEach((panel) => {
      const on = panel.dataset.ftwPanel === id;
      panel.classList.toggle("is-active", on);
      panel.hidden = !on;
    });
  }

  function setNavOpen(open) {
    root.classList.toggle("is-nav-open", open);
    const scrim = $("#ftw-nav-scrim");
    if (scrim) scrim.hidden = !open;
    $("#ftw-menu-btn")?.setAttribute("aria-expanded", String(!!open));
  }

  let activeFilter = "all";
  let searchQuery = "";

  function normalize(s) {
    return String(s || "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-|-$/g, "");
  }

  function productCollections(card) {
    return String(card.dataset.collections || "")
      .split(",")
      .map((s) => normalize(s.trim()))
      .filter(Boolean);
  }

  const FILTER_ALIASES = {
    "hoodies-sweatshirts": ["hoodies", "hoodies-sweat", "sweatshirts"],
    hoodies: ["hoodies-sweatshirts", "hoodies-sweat", "sweatshirts"],
    "t-shirts": ["t-shirt", "tees", "tee"],
    hats: ["hat", "caps", "cap", "beanies"],
    bottoms: ["bottom", "shorts", "pants"],
    jackets: ["jacket", "shells"],
    accessories: ["accessory", "bags", "bag"],
  };

  const TYPE_FILTER = {
    "t-shirts": "t-shirts",
    "t-shirt": "t-shirts",
    tshirts: "t-shirts",
    shirts: "t-shirts",
    shirt: "t-shirts",
    "tank-tops": "t-shirts",
    "tank-top": "t-shirts",
    tanktops: "t-shirts",
    womens: "womens",
    women: "womens",
    bottoms: "bottoms",
    lifestyle: "lifestyle",
    hats: "hats",
    hat: "hats",
    "hoodies-sweatshirts": "hoodies-sweatshirts",
    hoodies: "hoodies-sweatshirts",
    hoodie: "hoodies-sweatshirts",
    sweatshirts: "hoodies-sweatshirts",
    sweatshirt: "hoodies-sweatshirts",
    crewneck: "hoodies-sweatshirts",
    crewnecks: "hoodies-sweatshirts",
    jackets: "jackets",
    jacket: "jackets",
    "puffer-jackets": "jackets",
    "puffer-jacket": "jackets",
    puffers: "jackets",
    puffer: "jackets",
    accessories: "accessories",
    accessory: "accessories",
  };

  function productTypeKeys(card) {
    const keys = new Set();
    [card.dataset.type, card.dataset.category].forEach((value) => {
      const handle = normalize(value);
      if (!handle) return;
      keys.add(TYPE_FILTER[handle] || handle);
    });
    return keys;
  }

  function matchesCategory(cols, active, card) {
    const types = productTypeKeys(card);
    if (types.has(active)) return true;
    const alts = FILTER_ALIASES[active] || [];
    if (alts.some((alias) => types.has(alias) || types.has(TYPE_FILTER[alias] || alias))) return true;
    if (types.size) return false;
    if (cols.includes(active)) return true;
    return alts.some((alias) => cols.includes(alias));
  }

  const productFitCache = new Map();

  function productContentBounds(img) {
    const key = img.currentSrc || img.src;
    if (productFitCache.has(key)) return productFitCache.get(key);
    const n = 48;
    const canvas = document.createElement("canvas");
    canvas.width = n;
    canvas.height = n;
    const ctx = canvas.getContext("2d", { willReadFrequently: true });
    if (!ctx) return null;
    try {
      ctx.drawImage(img, 0, 0, n, n);
      const data = ctx.getImageData(0, 0, n, n).data;
      const at = (x, y) => {
        const i = (y * n + x) * 4;
        return [data[i], data[i + 1], data[i + 2], data[i + 3]];
      };
      const probes = [at(1, 1), at(n - 2, 1), at(1, n - 2), at(n - 2, n - 2)];
      const bg = probes
        .reduce((sum, px) => [sum[0] + px[0], sum[1] + px[1], sum[2] + px[2], sum[3] + px[3]], [0, 0, 0, 0])
        .map((v) => v / probes.length);
      let minX = n;
      let minY = n;
      let maxX = -1;
      let maxY = -1;
      for (let y = 0; y < n; y += 1) {
        for (let x = 0; x < n; x += 1) {
          const i = (y * n + x) * 4;
          const alpha = data[i + 3];
          if (alpha < 18) continue;
          const dist =
            Math.abs(data[i] - bg[0]) + Math.abs(data[i + 1] - bg[1]) + Math.abs(data[i + 2] - bg[2]);
          const alphaGap = Math.abs(alpha - bg[3]);
          if (dist < 46 && alphaGap < 40) continue;
          if (x < minX) minX = x;
          if (y < minY) minY = y;
          if (x > maxX) maxX = x;
          if (y > maxY) maxY = y;
        }
      }
      if (maxX < 0) {
        productFitCache.set(key, null);
        return null;
      }
      const bounds = {
        x: minX / n,
        y: minY / n,
        w: Math.max(0.08, (maxX - minX + 1) / n),
        h: Math.max(0.08, (maxY - minY + 1) / n),
      };
      productFitCache.set(key, bounds);
      return bounds;
    } catch (_) {
      productFitCache.set(key, null);
      return null;
    }
  }

  function fitProductImage(img) {
    const box = img.closest(".ftw-product__media");
    if (!box || !img.naturalWidth || !img.naturalHeight) return;
    const boxW = box.clientWidth;
    const boxH = box.clientHeight;
    if (!boxW || !boxH) return;
    const bounds = productContentBounds(img);
    if (!bounds) return;
    const imgRatio = img.naturalWidth / img.naturalHeight;
    const boxRatio = boxW / boxH;
    const drawW = imgRatio > boxRatio ? boxW : boxH * imgRatio;
    const drawH = imgRatio > boxRatio ? boxW / imgRatio : boxH;
    const contentW = drawW * bounds.w;
    const contentH = drawH * bounds.h;
    const target = 0.84;
    const scale = Math.min(2.35, Math.max(0.8, Math.min((boxW * target) / contentW, (boxH * target) / contentH)));
    img.style.transform = `scale(${scale})`;
  }

  function fitSheetImage(img) {
    const shot = img.closest(".ftw-sheet__shot");
    if (!shot || !img.naturalWidth || !img.naturalHeight) return;
    const boxW = shot.clientWidth;
    const boxH = shot.clientHeight;
    if (!boxW || !boxH) return;
    const bounds = productContentBounds(img);
    if (!bounds) return;
    const imgRatio = img.naturalWidth / img.naturalHeight;
    const boxRatio = boxW / boxH;
    const drawW = imgRatio > boxRatio ? boxW : boxH * imgRatio;
    const drawH = imgRatio > boxRatio ? boxW / imgRatio : boxH;
    const contentW = drawW * bounds.w;
    const contentH = drawH * bounds.h;
    const scale = Math.min(
      2.05,
      Math.max(1, Math.min((boxW * 0.96) / contentW, (boxH * 0.78) / contentH))
    );
    const contentCenter = (boxH - drawH) / 2 + drawH * (bounds.y + bounds.h / 2);
    const scaledCenter = boxH / 2 + (contentCenter - boxH / 2) * scale;
    const half = (contentH * scale) / 2;
    const minTop = Math.min(boxH * 0.08, 28);
    let desired = boxH * 0.44;
    desired = Math.max(desired, minTop + half);
    desired = Math.min(desired, boxH - 12 - half);
    if (desired < minTop + half) desired = scaledCenter;
    const shift = desired - scaledCenter;
    img.style.transformOrigin = "center center";
    img.style.transform = `translateY(${shift}px) scale(${scale})`;
  }

  function fitSheetImages() {
    $$(".ftw-sheet__shot img").forEach((img) => {
      if (img.complete && img.naturalWidth) {
        fitSheetImage(img);
        return;
      }
      if (img.dataset.sheetFit) return;
      img.dataset.sheetFit = "1";
      img.addEventListener("load", () => fitSheetImage(img), { once: true });
    });
  }

  function fitProductImages() {
    $$(".ftw-product__media img", root).forEach((img) => {
      if (img.complete && img.naturalWidth) {
        fitProductImage(img);
        return;
      }
      if (img.dataset.fitBound) return;
      img.dataset.fitBound = "1";
      img.addEventListener("load", () => fitProductImage(img), { once: true });
    });
  }

  function catalogCard(product, collections) {
    const variants = (product.variants || []).map((variant) => {
      const cents = Math.round(Number(variant.price || 0) * 100);
      const options = [variant.option1, variant.option2, variant.option3].filter(
        (value) => value && value !== "Default Title"
      );
      const image = variant.featured_image?.src || variant.featured_image || null;
      return {
        id: variant.id,
        title: variant.title,
        available: variant.available !== false,
        price: formatMoney(cents),
        options,
        image: typeof image === "string" ? image : null,
      };
    });
    const images = (product.images || []).map((image) => image.src).filter(Boolean);
    const first = variants.find((variant) => variant.available) || variants[0];
    const available = variants.some((variant) => variant.available);
    const created = Math.floor(new Date(product.created_at || 0).getTime() / 1000) || 0;
    const title = product.title || "Piece";
    const type = product.product_type || "";
    const price = first?.price || "";
    const img = images[0] || first?.image || "";
    const outfitImage = variants.find((variant) => variant.image)?.image || img;
    const options = Array.isArray(product.options) ? product.options : [];
    return `<a class="ftw-product${available ? "" : " is-sold"}" href="/products/${escapeHtml(product.handle)}" role="listitem"
      data-product="${escapeHtml(product.handle)}"
      data-title="${escapeHtml(title)}"
      data-collections="${escapeHtml(collections || "")}"
      data-type="${escapeHtml(type)}"
      data-drop="new"
      data-created="${created}"
      data-price="${escapeHtml(price)}"
      data-image="${escapeHtml(img)}"
      data-outfit-image="${escapeHtml(outfitImage)}"
      data-images='${escapeHtml(JSON.stringify(images))}'
      data-url="/products/${escapeHtml(product.handle)}"
      data-variant-id="${first?.id || ""}"
      data-available="${available ? "1" : "0"}"
      data-description=""
      data-options='${escapeHtml(JSON.stringify(options))}'
      data-variants='${escapeHtml(JSON.stringify(variants))}'>
      <div class="ftw-product__media">
        ${img ? `<img src="${escapeHtml(img)}" alt="${escapeHtml(title)}" width="600" height="720" loading="lazy" crossorigin="anonymous">` : ""}
        ${
          available
            ? `<button type="button" class="ftw-product__quick" data-ftw-quick-add aria-label="Choose size and color">+ ADD</button>`
            : `<span class="ftw-product__stamp">SOLD OUT</span>`
        }
      </div>
      <div class="ftw-product__meta">
        <span class="ftw-product__name">${escapeHtml(title)}</span>
        <span class="ftw-product__price">${available ? escapeHtml(price) : "SOLD OUT"}</span>
      </div>
    </a>`;
  }

  async function hydrateCatalog() {
    const grid = $("#ftw-grid", root);
    if (!grid) return;
    const seen = new Set($$(".ftw-product", grid).map((card) => card.dataset.product).filter(Boolean));
    let page = 1;
    while (page <= 20) {
      let data;
      try {
        const res = await fetch(`/products.json?limit=250&page=${page}`, {
          headers: { Accept: "application/json" },
        });
        if (!res.ok) break;
        data = await res.json();
      } catch (_) {
        break;
      }
      const list = Array.isArray(data?.products) ? data.products : [];
      if (!list.length) break;
      const html = list
        .filter((product) => product?.handle && !seen.has(product.handle))
        .map((product) => {
          seen.add(product.handle);
          return catalogCard(product, "");
        })
        .join("");
      if (html) grid.insertAdjacentHTML("beforeend", html);
      if (list.length < 250) break;
      page += 1;
    }
  }

  function settleCatalog() {
    const grid = $("#ftw-grid", root);
    const total = Number(grid?.dataset.catalogTotal || 0);
    const have = grid ? $$(".ftw-product", grid).length : 0;
    const needsMore = Boolean(grid) && !isLocal && total > have;
    const finish = (added) => {
      if (added || !grid?.dataset.sorted) sortGridByNewest();
      if (grid) {
        grid.dataset.sorted = "1";
        grid.classList.remove("is-booting");
      }
      applyFilters();
      fitProductImages();
    };
    if (!needsMore) {
      finish(false);
      return;
    }
    grid.classList.add("is-booting");
    hydrateCatalog().finally(() => finish(true));
  }

  function sortGridByNewest() {
    const grid = $("#ftw-grid", root);
    if (!grid) return;
    $$(".ftw-product", grid)
      .sort((a, b) => Number(b.dataset.created || 0) - Number(a.dataset.created || 0))
      .forEach((card) => grid.appendChild(card));
  }

  function applyFilters() {
    const q = searchQuery.trim().toLowerCase();
    const active = normalize(activeFilter);
    let visible = 0;
    $$(".ftw-product", root).forEach((card) => {
      const drop = card.dataset.drop || "new";
      const cols = productCollections(card);
      const title = (card.dataset.title || card.textContent || "").toLowerCase();
      let show = true;

      if (active === "archive") {
        show = false;
      } else if (active === "all" || active === "new") {
        show = drop !== "archive";
      } else {
        show = matchesCategory(cols, active, card);
      }

      if (show && q) show = title.includes(q);
      card.classList.toggle("is-filtered-out", !show);
      if (show) visible += 1;
    });

    const grid = $("#ftw-grid", root);
    const looks = $("#ftw-lookbooks", root);
    if (looks) looks.hidden = active !== "archive";
    if (!grid) return;
    let empty = $("#ftw-filter-empty", root);
    if (!visible && active !== "archive") {
      if (!empty) {
        empty = document.createElement("p");
        empty.className = "ftw-empty";
        empty.id = "ftw-filter-empty";
        grid.appendChild(empty);
      }
      empty.hidden = false;
      empty.textContent = q
        ? "NO MATCHES."
        : "NO PRODUCTS IN THIS COLLECTION. Connect it in the theme editor.";
    } else if (empty) {
      empty.hidden = true;
    }
    fitProductImages();
  }

  function setFilter(key) {
    activeFilter = key || "all";
    $$("[data-ftw-filter]", root).forEach((btn) => {
      btn.classList.toggle("is-active", btn.dataset.ftwFilter === activeFilter);
    });
    applyFilters();
    setNavOpen(false);
  }

  function parseVariants(raw) {
    if (!raw) return [];
    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  function parseImages(raw, fallback) {
    const list = parseVariants(raw).filter((x) => typeof x === "string" && x);
    if (list.length) return list;
    return fallback ? [fallback] : [];
  }

  function descLines(desc) {
    const clean = String(desc || "")
      .replace(/\s+/g, " ")
      .trim();
    if (!clean) return ["LIMITED DROP", "NO RESTOCKS", "FOR THE WIN"];
    const parts = clean
      .split(/[.!?]+/)
      .map((s) => s.trim())
      .filter(Boolean)
      .slice(0, 4);
    return parts.length ? parts.map((p) => p.toUpperCase()) : [clean.toUpperCase()];
  }

  function syncAddButton() {
    const btn = $("#ftw-sheet-add");
    if (!btn) return;
    if (!sheetAvailable) {
      btn.textContent = "SOLD OUT";
      btn.disabled = true;
      return;
    }
    btn.textContent = "ADD TO CART";
    btn.disabled = !selectedVariantId;
  }

  function sheetSlidesSideways() {
    return window.matchMedia("(max-width: 900px)").matches;
  }

  function moveSheet(index, animate) {
    const stage = $("#ftw-sheet-stack");
    const reel = stage?.querySelector(".ftw-sheet__reel");
    const count = stage ? $$(".ftw-sheet__shot", stage).length : 0;
    if (!stage || !reel || !count) return;
    if (!sheetSlidesSideways()) {
      reel.style.transition = "none";
      reel.style.transform = "none";
      return;
    }
    const next = Math.max(0, Math.min(count - 1, index));
    sheetImageIndex = next;
    const frame = reel.clientWidth || stage.clientWidth;
    reel.style.transition = animate === false ? "none" : "";
    reel.style.transform = `translate3d(${-next * frame}px, 0, 0)`;
    $$(".ftw-sheet__dot", stage).forEach((dot, i) => {
      if (i === next) dot.setAttribute("aria-current", "true");
      else dot.removeAttribute("aria-current");
    });
  }

  function buildStack(title) {
    const stage = $("#ftw-sheet-stack");
    if (!stage) return;
    const imgs = sheetImages.length ? sheetImages : [];
    const shots = imgs
      .map(
        (src, n) =>
          `<div class="ftw-sheet__shot"><img src="${src}" alt="${escapeHtml(title || "")}" width="1200" height="1200" draggable="false" loading="${n === 0 ? "eager" : "lazy"}" crossorigin="anonymous"></div>`
      )
      .join("");
    const dots =
      imgs.length > 1
        ? `<div class="ftw-sheet__dots">${imgs
            .map(
              (_, n) =>
                `<button type="button" class="ftw-sheet__dot" data-ftw-shot="${n}" aria-label="Image ${n + 1}"${n === 0 ? ' aria-current="true"' : ""}></button>`
            )
            .join("")}</div>`
        : "";
    stage.innerHTML = `<div class="ftw-sheet__reel">${shots}</div>${dots}`;
    sheetImageIndex = 0;
  }

  function parseOptions(raw) {
    try {
      const parsed = JSON.parse(raw || "[]");
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  function variantOptionValues(v) {
    if (Array.isArray(v.options) && v.options.length) return v.options.map(String);
    if (v.title && v.title !== "Default Title") {
      return String(v.title)
        .split(" / ")
        .map((s) => s.trim())
        .filter(Boolean);
    }
    return [];
  }

  function inferOptionDefs(variants) {
    const names = ["Option 1", "Option 2", "Option 3"];
    const buckets = [[], [], []];
    variants.forEach((v) => {
      variantOptionValues(v).forEach((val, i) => {
        if (i < 3 && val && !buckets[i].includes(val)) buckets[i].push(val);
      });
    });
    return buckets
      .map((values, i) => ({ name: names[i], values }))
      .filter((o) => o.values.length);
  }

  function findMatchingVariant() {
    return (
      sheetVariants.find((v) => {
        const opts = variantOptionValues(v);
        if (!sheetSelectedOptions.length) return false;
        return sheetSelectedOptions.every((val, i) => opts[i] === val);
      }) || null
    );
  }

  function optionHasAnyVariant(index, value, draft) {
    const probe = draft.slice();
    probe[index] = value;
    return sheetVariants.some((v) => {
      const opts = variantOptionValues(v);
      return probe.every((val, i) => val == null || val === "" || opts[i] === val);
    });
  }

  function syncVariantFromOptions() {
    const match = findMatchingVariant();
    selectedVariantId = match ? match.id : null;
    if (match?.price) $("#ftw-sheet-price").textContent = match.price;

    const btn = $("#ftw-sheet-add");
    if (!btn) return;
    if (!match) {
      btn.textContent = "UNAVAILABLE";
      btn.disabled = true;
      return;
    }
    if (!match.available) {
      btn.textContent = "SOLD OUT";
      btn.disabled = true;
      return;
    }
    sheetAvailable = true;
    syncAddButton();
  }

  function buildSizes(card) {
    const host = $("#ftw-sheet-sizes");
    host.innerHTML = "";
    selectedVariantId = null;
    sheetOptionDefs = parseOptions(card.dataset.options);
    if (!sheetOptionDefs.length) sheetOptionDefs = inferOptionDefs(sheetVariants);

    const hasRealOptions = sheetOptionDefs.some((o) => o.values && o.values.length);
    const onlyDefault =
      sheetVariants.length <= 1 &&
      (!sheetVariants[0] || !sheetVariants[0].title || sheetVariants[0].title === "Default Title");

    if (!hasRealOptions || onlyDefault) {
      selectedVariantId = Number(card.dataset.variantId) || sheetVariants[0]?.id || null;
      syncAddButton();
      return;
    }

    const firstAvailable = sheetVariants.find((v) => v.available) || sheetVariants[0];
    sheetSelectedOptions = variantOptionValues(firstAvailable || {});

    sheetOptionDefs.forEach((opt, index) => {
      if (!sheetSelectedOptions[index]) sheetSelectedOptions[index] = opt.values[0];

      const wrap = document.createElement("label");
      wrap.className = "ftw-sheet__option";

      const label = document.createElement("span");
      label.className = "ftw-sheet__option-label";
      label.textContent = String(opt.name || `Option ${index + 1}`).toUpperCase();

      const select = document.createElement("select");
      select.className = "ftw-sheet__select";
      select.dataset.optionIndex = String(index);
      select.setAttribute("aria-label", opt.name || `Option ${index + 1}`);

      opt.values.forEach((value) => {
        const optionEl = document.createElement("option");
        optionEl.value = value;
        optionEl.textContent = String(value).toUpperCase();
        const exists = optionHasAnyVariant(index, value, sheetSelectedOptions);
        optionEl.disabled = !exists;
        if (sheetSelectedOptions[index] === value) optionEl.selected = true;
        select.appendChild(optionEl);
      });

      select.addEventListener("change", () => {
        sheetSelectedOptions[index] = select.value;
        // refresh disabled states for other selects
        $$(".ftw-sheet__select", host).forEach((sel) => {
          const i = Number(sel.dataset.optionIndex);
          [...sel.options].forEach((optEl) => {
            optEl.disabled = !optionHasAnyVariant(i, optEl.value, sheetSelectedOptions);
          });
        });
        syncVariantFromOptions();
      });

      wrap.appendChild(label);
      wrap.appendChild(select);
      host.appendChild(wrap);
    });

    syncVariantFromOptions();
  }

  function openSheet(card) {
    const sheet = $("#ftw-sheet");
    if (!sheet || !card) return;

    closeDrawers();
    setNavOpen(false);

    const title = card.dataset.title || "";
    const price = card.dataset.price || "";
    const image = card.dataset.image || card.querySelector("img")?.src || "";
    const desc = sheetDescription(card);
    if (title) document.title = `${title} – ${root.dataset.shopTitle || "BIZIBOIZ"}`;
    sheetAvailable = card.dataset.available !== "0";
    sheetVariants = parseVariants(card.dataset.variants);
    sheetImages = parseImages(card.dataset.images, image);
    sheetImageIndex = 0;

    $("#ftw-sheet-title").textContent = title;
    $("#ftw-sheet-price").textContent = sheetAvailable ? price : "SOLD OUT";
    $("#ftw-sheet-lines").innerHTML = descLines(desc)
      .map((l) => `<li>${l}</li>`)
      .join("");

    $$("[data-ftw-detail-panel]", root).forEach((p) => {
      p.hidden = true;
    });

    buildStack(title);
    buildSizes(card);
    sheetImageIndex = 0;

    sheet.hidden = false;
    document.body.classList.add("ftw-sheet-open");
    requestAnimationFrame(() => {
      const layout = $(".ftw-sheet__layout");
      const panel = $(".ftw-sheet__panel");
      if (layout) layout.scrollTop = 0;
      panel?.classList.remove("is-dragging");
      panel?.style.removeProperty("--ftw-sheet-y");
      applySheetStage(true);
      moveSheet(0, false);
      fitSheetImages();
      sheet.classList.add("is-open");
      sheetOpen = true;
      $(".ftw-sheet__back")?.focus();
    });
  }

  function openProduct(card) {
    if (!card) return;
    const path = productPath(card.dataset.url || card.getAttribute("href") || "");
    if (path && path !== location.pathname + location.search) {
      history.pushState({ ftwSheet: path }, "", path);
    }
    openSheet(card);
  }

  let sheetHistoryPending = false;

  function closeSheet(instant, fromHistory) {
    const sheet = $("#ftw-sheet");
    if (!sheet || sheet.hidden) return;
    if (!fromHistory && sheetHistoryPending) return;
    if (!fromHistory && history.state && history.state.ftwSheet) {
      sheetHistoryPending = true;
      history.back();
      return;
    }
    sheetHistoryPending = false;
    if (!fromHistory && productHandleFromPath()) {
      history.pushState({ ftwShop: true }, "", shopPath());
    }
    document.title = shopDocumentTitle;
    sheet.classList.remove("is-open");
    sheetOpen = false;
    document.body.classList.remove("ftw-sheet-open");
    const finish = () => {
      sheet.hidden = true;
      selectedVariantId = null;
    };
    if (instant) finish();
    else setTimeout(finish, 240);
    sheetVariants = [];
    sheetImages = [];
  }

  const sheetGrab = $(".ftw-sheet__grab");
  const sheetPanel = $(".ftw-sheet__panel");
  let sheetPull = null;

  function sheetPullY(clientY) {
    if (!sheetPull) return 0;
    return Math.max(0, clientY - sheetPull.y);
  }

  sheetGrab?.addEventListener("pointerdown", (e) => {
    if (!sheetOpen || window.innerWidth > 900 || !sheetPanel) return;
    if (e.button != null && e.button !== 0) return;
    e.preventDefault();
    sheetPanel.classList.add("is-dragging");
    sheetPull = { id: e.pointerId, y: e.clientY, lastY: e.clientY, lastT: performance.now(), vy: 0 };
    try {
      sheetGrab.setPointerCapture(e.pointerId);
    } catch (_) {}
  });

  sheetGrab?.addEventListener("pointermove", (e) => {
    if (!sheetPull || e.pointerId !== sheetPull.id || !sheetPanel) return;
    const now = performance.now();
    const dt = now - sheetPull.lastT;
    if (dt > 0) sheetPull.vy = (e.clientY - sheetPull.lastY) / dt;
    sheetPull.lastY = e.clientY;
    sheetPull.lastT = now;
    sheetPanel.style.setProperty("--ftw-sheet-y", `${sheetPullY(e.clientY)}px`);
  });

  function endSheetPull(e) {
    if (!sheetPull || (e && e.pointerId !== sheetPull.id) || !sheetPanel) return;
    const dy = sheetPullY(e?.clientY ?? sheetPull.lastY);
    const flick = sheetPull.vy > 0.55;
    sheetPull = null;
    sheetPanel.classList.remove("is-dragging");
    if (dy > 96 || (flick && dy > 24)) {
      const off = Math.max(sheetPanel.offsetHeight, window.innerHeight);
      sheetPanel.style.setProperty("--ftw-sheet-y", `${off}px`);
      let settled = false;
      const done = () => {
        if (settled) return;
        settled = true;
        sheetPanel.style.removeProperty("--ftw-sheet-y");
        closeSheet(true);
      };
      sheetPanel.addEventListener("transitionend", done, { once: true });
      setTimeout(done, 320);
      return;
    }
    sheetPanel.style.setProperty("--ftw-sheet-y", "0px");
  }

  sheetGrab?.addEventListener("pointerup", endSheetPull);
  sheetGrab?.addEventListener("pointercancel", endSheetPull);

  async function addVariantToCart(variantId, { openBag = false, sourceBtn = null } = {}) {
    if (!variantId) return false;

    if (isLocal) {
      const count = Number($("#cart-count")?.textContent || 0) + 1;
      updateTrayCart(count);
      toast("ADDED TO CART.");
      if (openBag) openDrawer("ftw-bag");
      return true;
    }

    if (sourceBtn) sourceBtn.disabled = true;
    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
      });
      if (!res.ok) throw new Error("add failed");
      const cart = await fetchCart();
      updateTrayCart(cart.item_count);
      toast("ADDED TO CART.");
      if (openBag) openDrawer("ftw-bag");
      else if (!$("#ftw-bag")?.hidden) renderCart();
      if (sourceBtn && sourceBtn.hasAttribute("data-ftw-quick-add")) {
        sourceBtn.disabled = false;
        sourceBtn.textContent = "+ ADD";
      }
      return true;
    } catch {
      toast("COULDN'T ADD. TRY AGAIN.");
      if (sourceBtn) sourceBtn.disabled = false;
      return false;
    }
  }

  async function addToCart() {
    const addBtn = $("#ftw-sheet-add");
    if (!selectedVariantId || addBtn?.disabled) {
      toast("PICK YOUR OPTIONS.");
      return;
    }
    addBtn.disabled = true;
    const ok = await addVariantToCart(selectedVariantId, { openBag: true, sourceBtn: addBtn });
    if (ok) closeSheet(true);
    else addBtn.disabled = false;
  }

  $("#ftw-bag-btn")?.addEventListener("click", () => {
    const bag = $("#ftw-bag");
    if (bag?.hidden) openDrawer("ftw-bag");
    else closeDrawers();
  });

  $("#ftw-account-top-btn")?.addEventListener("click", toggleAccountDrawer);
  $$("[data-ftw-account]", root).forEach((btn) => btn.addEventListener("click", toggleAccountDrawer));

  $$("[data-ftw-contact]", root).forEach((btn) =>
    btn.addEventListener("click", () => openDrawer("ftw-contact"))
  );
  $("#ftw-menu-btn")?.addEventListener("click", () => setNavOpen(!root.classList.contains("is-nav-open")));

  $(".ftw-currency__open")?.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();
    const menu = e.currentTarget.closest(".ftw-currency");
    const more = menu?.querySelector(".ftw-currency__more");
    const open = Boolean(more?.hidden);
    if (more) more.hidden = !open;
    e.currentTarget.setAttribute("aria-expanded", open ? "true" : "false");
  });

  if (isLocal) {
    $(".ftw-currency")?.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-ftw-currency]");
      if (!btn) return;
      $$("[data-ftw-currency]", root).forEach((item) => {
        item.setAttribute("aria-pressed", item === btn ? "true" : "false");
      });
      const label = $(".ftw-currency__open span");
      if (label) label.textContent = btn.dataset.ftwCurrency || btn.textContent;
      const more = $(".ftw-currency__more");
      if (more) more.hidden = true;
      $(".ftw-currency__open")?.setAttribute("aria-expanded", "false");
    });
  }
  $("#ftw-nav-scrim")?.addEventListener("click", () => setNavOpen(false));
  $("#ftw-sheet-add")?.addEventListener("click", addToCart);
  $$("[data-ftw-theme]", root).forEach((btn) =>
    btn.addEventListener("click", () => setTheme(getTheme() === "dark" ? "light" : "dark"))
  );
  $("#ftw-outfit-close")?.addEventListener("click", closeOutfitChecker);
  $("#ftw-outfit-clear")?.addEventListener("click", resetOutfitStage);

  function onSearchInput(e) {
    searchQuery = e.target.value || "";
    const otherId = e.target.id === "ftw-search-input" ? "ftw-search-input-side" : "ftw-search-input";
    const other = $(`#${otherId}`);
    if (other && other.value !== searchQuery) other.value = searchQuery;
    applyFilters();
  }

  $("#ftw-search-input")?.addEventListener("input", onSearchInput);
  $("#ftw-search-input-side")?.addEventListener("input", onSearchInput);

  root.addEventListener("pointermove", onOutfitPointerMove);
  root.addEventListener("pointerup", onOutfitPointerUp);
  root.addEventListener("pointercancel", onOutfitPointerUp);

  root.addEventListener("pointerdown", (e) => {
    if (e.target.closest(".ftw-outfit__piece-kill")) return;

    const resizeHandle = e.target.closest(".ftw-outfit__piece-resize");
    if (resizeHandle) {
      e.preventDefault();
      e.stopPropagation();
      const piece = resizeHandle.closest(".ftw-outfit__piece");
      if (!piece) return;
      selectOutfitPiece(piece);
      const rect = piece.getBoundingClientRect();
      const cx = rect.left + rect.width / 2;
      const cy = rect.top + rect.height / 2;
      const startDist = Math.max(8, Math.hypot(e.clientX - cx, e.clientY - cy));
      startOutfitDrag(e, "resize", {
        el: piece,
        cx,
        cy,
        startDist,
        startScale: Number(piece.dataset.scale || 1),
      });
      return;
    }

    const rackItem = e.target.closest(".ftw-outfit__rack-item");
    if (rackItem) {
      e.preventDefault();
      wearOutfitPiece({
        id: rackItem.dataset.outfitId,
        image: rackItem.dataset.outfitSrc,
        title: rackItem.dataset.outfitTitle,
        price: rackItem.dataset.outfitPrice,
        variantId: rackItem.dataset.outfitVariant,
        slot: rackItem.dataset.outfitSlot,
      });
      return;
    }

    const piece = e.target.closest(".ftw-outfit__piece");
    if (piece) {
      e.preventDefault();
      selectOutfitPiece(piece);
      startOutfitDrag(e, "move", {
        el: piece,
        originLeft: parseFloat(piece.style.left) || 0,
        originTop: parseFloat(piece.style.top) || 0,
      });
    }
  });

  root.addEventListener("click", (e) => {
    if (e.target.closest("#ftw-outfit-open")) {
      openOutfitChecker();
      return;
    }

    const pieceKill = e.target.closest(".ftw-outfit__piece-kill");
    if (pieceKill) {
      const piece = pieceKill.closest(".ftw-outfit__piece");
      if (piece === outfitSelected) outfitSelected = null;
      piece?.remove();
      syncOutfitLists();
      return;
    }

    const outfitAdd = e.target.closest("[data-outfit-add]");
    if (outfitAdd) {
      const variantId = outfitAdd.dataset.outfitAdd;
      if (!variantId) return;
      addVariantToCart(variantId, { openBag: false, sourceBtn: outfitAdd }).then((ok) => {
        if (ok) {
          outfitAdd.textContent = "ADDED";
          outfitAdd.disabled = true;
        } else {
          outfitAdd.disabled = false;
          outfitAdd.textContent = "ADD TO CART";
        }
      });
      return;
    }

    if (e.target.closest("#ftw-outfit-stage") && !e.target.closest(".ftw-outfit__piece")) {
      selectOutfitPiece(null);
    }

    if (e.target.closest("[data-close-sheet]")) {
      closeSheet();
      return;
    }

    const detailBtn = e.target.closest("[data-ftw-detail]");
    if (detailBtn) {
      const key = detailBtn.dataset.ftwDetail;
      const panel = $(`[data-ftw-detail-panel="${key}"]`, root);
      if (panel) panel.hidden = !panel.hidden;
      return;
    }

    const sizeBtn = e.target.closest(".ftw-sheet__size");
    if (sizeBtn && !sizeBtn.disabled) {
      $$(".ftw-sheet__size", root).forEach((b) => b.classList.remove("is-active"));
      sizeBtn.classList.add("is-active");
      selectedVariantId = Number(sizeBtn.dataset.variantId);
      const match = sheetVariants.find((v) => String(v.id) === String(selectedVariantId));
      if (match?.price) $("#ftw-sheet-price").textContent = match.price;
      syncAddButton();
      return;
    }

    const quickAdd = e.target.closest("[data-ftw-quick-add]");
    if (quickAdd) {
      e.preventDefault();
      e.stopPropagation();
      const card = quickAdd.closest(".ftw-product");
      if (!card || card.classList.contains("is-sold")) return;
      openProduct(card);
      return;
    }

    const product = e.target.closest(".ftw-product");
    if (product && root.contains(product)) {
      e.preventDefault();
      openProduct(product);
      return;
    }

    const cartQtyBtn = e.target.closest("[data-cart-key][data-cart-qty]");
    if (cartQtyBtn) {
      const key = cartQtyBtn.dataset.cartKey;
      const qty = Number(cartQtyBtn.dataset.cartQty);
      cartQtyBtn.disabled = true;
      changeCartLine(key, qty).finally(() => {
        cartQtyBtn.disabled = false;
      });
      return;
    }

    const upsellBtn = e.target.closest("[data-upsell-add]");
    if (upsellBtn) {
      addVariantToCart(upsellBtn.dataset.upsellAdd, { sourceBtn: upsellBtn });
      return;
    }

    const filterBtn = e.target.closest("[data-ftw-filter]");
    if (filterBtn) {
      setFilter(filterBtn.dataset.ftwFilter);
      return;
    }
    if (e.target.closest("[data-close-drawer]")) {
      closeDrawers();
      return;
    }
    if (e.target.classList.contains("ftw-drawer")) {
      closeDrawers();
      return;
    }
    const tab = e.target.closest("[data-ftw-tab]");
    if (tab) {
      setTab(tab.dataset.ftwTab);
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    if (!$("#ftw-outfit")?.hidden) {
      closeOutfitChecker();
      return;
    }
    if (sheetOpen) closeSheet();
  });

  $("#contact-form")?.addEventListener("submit", (e) => {
    e.preventDefault();
    toast("YOU'RE ON THE LIST.");
    e.target.reset();
    closeDrawers();
  });

  updateTrayCart(Number(root.dataset.cartCount || 0));
  if (!isLocal) renderCart();
  settleCatalog();

  /* —— Mobile lock intro —— */
  const LOCK_KEY = "ftw-unlocked";
  const lockEl = $("#ftw-lock");
  const lockKnob = $("#ftw-lock-knob");
  const lockSlider = $("#ftw-lock-slider");
  const mobileMq = window.matchMedia("(max-width: 720px)");
  const lockReduce = window.matchMedia("(prefers-reduced-motion: reduce)");
  let lockDrag = null;
  let lockClockTimer = null;
  const lockWalls = (() => {
    const fromData = lockEl?.querySelector("[data-ftw-lock-walls]")?.getAttribute("data-ftw-lock-walls");
    if (fromData) return fromData.split("|").map((url) => url.trim()).filter(Boolean);
    try {
      const raw = document.getElementById("ftw-lock-walls")?.textContent;
      const list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list.filter(Boolean) : [];
    } catch (_) {
      return [];
    }
  })();
  const lockFrames = lockEl ? [...lockEl.querySelectorAll(".ftw-lock__wallpaper")] : [];
  let lockShot = 0;
  let lockFront = 0;
  let lockWallTimer = null;
  let lockWallToken = 0;

  function wasUnlocked() {
    try {
      return sessionStorage.getItem(LOCK_KEY) === "1";
    } catch (_) {
      return false;
    }
  }

  function markUnlocked() {
    try {
      sessionStorage.setItem(LOCK_KEY, "1");
    } catch (_) {}
  }

  function syncLockClock() {
    const clock = $("#ftw-lock-clock");
    const dateEl = $("#ftw-lock-date");
    if (!clock || !dateEl) return;
    const now = new Date();
    clock.textContent = now.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
    dateEl.textContent = now.toLocaleDateString([], {
      weekday: "long",
      month: "long",
      day: "numeric",
    });
  }

  function setLockProgress(px, maxX) {
    const x = Math.max(0, Math.min(px, maxX));
    const p = maxX > 0 ? x / maxX : 0;
    lockEl?.style.setProperty("--ftw-lock-x", `${x}px`);
    lockEl?.style.setProperty("--ftw-lock-p", String(p));
    if (lockKnob) lockKnob.style.transform = `translateX(${x}px)`;
    lockSlider?.setAttribute("aria-valuenow", String(Math.round(p * 100)));
    return { x, p, maxX };
  }

  function resetLockKnob() {
    if (!lockKnob || !lockEl) return;
    lockKnob.style.transition = "transform 200ms var(--ftw-ease)";
    setLockProgress(0, 1);
    requestAnimationFrame(() => {
      setTimeout(() => {
        if (lockKnob) lockKnob.style.transition = "";
      }, 220);
    });
  }

  function stopLockWalls() {
    lockWallToken += 1;
    if (lockWallTimer) {
      clearTimeout(lockWallTimer);
      lockWallTimer = null;
    }
  }

  function armLockWalls() {
    if (lockWallTimer) clearTimeout(lockWallTimer);
    lockWallTimer = null;
    if (!lockEl || lockEl.hidden || document.hidden || lockWalls.length < 2) return;
    lockWallTimer = setTimeout(stepLockWall, 2000);
  }

  function lockWallUrl(index) {
    const count = lockWalls.length;
    if (!count) return "";
    return lockWalls[((index % count) + count) % count];
  }

  function sameLockUrl(a, b) {
    if (!a || !b) return false;
    try {
      return new URL(a, location.href).href === new URL(b, location.href).href;
    } catch (_) {
      return a === b;
    }
  }

  function preloadLockWall(index) {
    const frame = lockFrames[1 - lockFront];
    const url = lockWallUrl(index);
    if (!frame || !url || sameLockUrl(frame.getAttribute("src"), url)) return;
    frame.src = url;
  }

  function showLockWall(index, done) {
    if (!lockFrames.length || !lockWalls.length) return;
    const next = ((index % lockWalls.length) + lockWalls.length) % lockWalls.length;
    if (lockFrames.length < 2 || lockWalls.length < 2) {
      lockShot = next;
      done?.();
      return;
    }
    const token = ++lockWallToken;
    const front = lockFrames[lockFront];
    const back = lockFrames[1 - lockFront];
    const url = lockWalls[next];
    const finish = () => {
      if (token !== lockWallToken) return;
      back.classList.remove("is-in");
      back.classList.add("is-on");
      front.classList.remove("is-on");
      lockFront = 1 - lockFront;
      lockShot = next;
      preloadLockWall(next + 1);
      done?.();
    };
    const reveal = () => {
      if (token !== lockWallToken || !back.naturalWidth) {
        if (token === lockWallToken) {
          lockShot = next;
          done?.();
        }
        return;
      }
      if (lockReduce.matches) {
        finish();
        return;
      }
      back.classList.add("is-in");
      let settled = false;
      const settle = () => {
        if (settled) return;
        settled = true;
        finish();
      };
      const onEnd = (e) => {
        if (e.propertyName !== "transform") return;
        back.removeEventListener("transitionend", onEnd);
        settle();
      };
      back.addEventListener("transitionend", onEnd);
      setTimeout(settle, 1100);
    };
    if (sameLockUrl(back.getAttribute("src") || back.src, url) && back.complete) {
      reveal();
      return;
    }
    const onLoad = () => {
      back.removeEventListener("load", onLoad);
      back.removeEventListener("error", onErr);
      reveal();
    };
    const onErr = () => {
      back.removeEventListener("load", onLoad);
      back.removeEventListener("error", onErr);
      if (token !== lockWallToken) return;
      lockShot = next;
      done?.();
    };
    back.addEventListener("load", onLoad);
    back.addEventListener("error", onErr);
    back.src = url;
    if (back.complete) onLoad();
  }

  function stepLockWall() {
    lockWallTimer = null;
    showLockWall(lockShot + 1, armLockWalls);
  }

  function startLockWalls() {
    if (!lockFrames[0] || !lockWalls.length || lockWallTimer) return;
    if (!lockFrames[0].getAttribute("src")) lockFrames[0].src = lockWalls[0];
    lockFrames[lockFront]?.classList.add("is-on");
    preloadLockWall((lockShot + 1) % lockWalls.length);
    armLockWalls();
  }

  let lockNoteTimers = [];
  let lockRingPlayed = false;
  let lockRingCtx = null;
  let lockRingWait = false;

  function armLockRingGesture() {
    if (lockRingPlayed || lockRingWait || !lockEl) return;
    lockRingWait = true;
    lockEl.addEventListener("pointerdown", () => {
      lockRingWait = false;
      playLockRing();
    }, { once: true });
  }

  function playLockRing() {
    if (lockRingPlayed) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const AudioCtx = window.AudioContext || window.webkitAudioContext;
    if (!AudioCtx) return;
    const ctx = lockRingCtx || new AudioCtx();
    lockRingCtx = ctx;
    const start = () => {
      if (ctx.state !== "running") {
        armLockRingGesture();
        return;
      }
      if (lockRingPlayed) return;
      lockRingPlayed = true;
      const t = ctx.currentTime + 0.02;
      [880, 1318.5].forEach((freq, i) => {
        const osc = ctx.createOscillator();
        const tone = ctx.createGain();
        osc.type = "sine";
        osc.frequency.value = freq;
        const at = t + i * 0.13;
        tone.gain.setValueAtTime(0.0001, at);
        tone.gain.exponentialRampToValueAtTime(0.16, at + 0.018);
        tone.gain.exponentialRampToValueAtTime(0.0001, at + 0.32);
        osc.connect(tone);
        tone.connect(ctx.destination);
        osc.start(at);
        osc.stop(at + 0.34);
      });
    };
    ctx.resume().then(start).catch(() => armLockRingGesture());
  }

  function armLockNote() {
    const notes = lockEl ? $$(".ftw-lock__note", lockEl) : [];
    if (!notes.length) return;
    notes.forEach((note) => note.classList.remove("is-in"));
    clearLockNote(false);
    lockNoteTimers.push(
      setTimeout(() => {
        if (!lockEl || lockEl.hidden) return;
        notes[0]?.classList.add("is-in");
        playLockRing();
        if (notes[1]) {
          lockNoteTimers.push(
            setTimeout(() => {
              if (!lockEl || lockEl.hidden) return;
              notes[1].classList.add("is-in");
            }, 280)
          );
        }
      }, 1000)
    );
  }

  function clearLockNote(reset = true) {
    lockNoteTimers.forEach((id) => clearTimeout(id));
    lockNoteTimers = [];
    if (reset) {
      lockEl?.querySelectorAll(".ftw-lock__note").forEach((note) => note.classList.remove("is-in"));
    }
  }

  function dismissLock() {
    if (!lockEl || lockEl.hidden) return;
    markUnlocked();
    stopLockWalls();
    clearLockNote();
    lockEl.classList.add("is-unlocking");
    document.body.classList.remove("ftw-locked");
    if (lockClockTimer) {
      clearInterval(lockClockTimer);
      lockClockTimer = null;
    }
    setTimeout(() => {
      lockEl.hidden = true;
      lockEl.classList.remove("is-unlocking");
    }, 280);
  }

  function showLock() {
    if (!lockEl || !mobileMq.matches || wasUnlocked() || productHandleFromPath()) {
      if (lockEl) lockEl.hidden = true;
      document.body.classList.remove("ftw-locked");
      stopLockWalls();
      clearLockNote();
      return;
    }
    if (lockEl.parentElement !== document.body) document.body.appendChild(lockEl);
    lockEl.hidden = false;
    lockEl.style.display = "grid";
    lockEl.style.position = "fixed";
    lockEl.style.top = "0";
    lockEl.style.right = "0";
    lockEl.style.bottom = "0";
    lockEl.style.left = "0";
    lockEl.style.width = "100%";
    lockEl.style.height = "100dvh";
    lockEl.style.zIndex = "300";
    document.body.classList.add("ftw-locked");
    syncLockClock();
    setLockProgress(0, 1);
    if (lockClockTimer) clearInterval(lockClockTimer);
    lockClockTimer = setInterval(syncLockClock, 30000);
    startLockWalls();
    armLockNote();
  }

  function lockMaxX() {
    const track = lockEl?.querySelector(".ftw-lock__track");
    if (!track || !lockKnob) return 0;
    return Math.max(0, track.clientWidth - lockKnob.offsetWidth - 6);
  }

  lockKnob?.addEventListener("pointerdown", (e) => {
    if (!mobileMq.matches || lockEl?.hidden) return;
    if (e.button != null && e.button !== 0) return;
    e.preventDefault();
    const maxX = lockMaxX();
    const startX = e.clientX;
    const current = Number.parseFloat(getComputedStyle(lockEl).getPropertyValue("--ftw-lock-x")) || 0;
    lockDrag = { pointerId: e.pointerId, startX, origin: current, maxX };
    lockKnob.style.transition = "";
    try {
      lockKnob.setPointerCapture(e.pointerId);
    } catch (_) {}
  });

  lockKnob?.addEventListener("pointermove", (e) => {
    if (!lockDrag || e.pointerId !== lockDrag.pointerId) return;
    const dx = e.clientX - lockDrag.startX;
    setLockProgress(lockDrag.origin + dx, lockDrag.maxX);
  });

  function endLockDrag(e) {
    if (!lockDrag || (e && e.pointerId !== lockDrag.pointerId)) return;
    const maxX = lockDrag.maxX || lockMaxX();
    const x = Number.parseFloat(getComputedStyle(lockEl).getPropertyValue("--ftw-lock-x")) || 0;
    const { p } = setLockProgress(x, maxX);
    lockDrag = null;
    if (p >= 0.72) {
      setLockProgress(maxX, maxX);
      dismissLock();
    } else {
      resetLockKnob();
    }
  }

  lockKnob?.addEventListener("pointerup", endLockDrag);
  lockKnob?.addEventListener("pointercancel", endLockDrag);

  lockSlider?.addEventListener("keydown", (e) => {
    if (lockEl?.hidden) return;
    if (e.key === "Enter" || e.key === " " || e.key === "ArrowRight") {
      e.preventDefault();
      dismissLock();
    }
  });

  lockEl?.querySelector(".ftw-lock__hint")?.addEventListener("click", dismissLock);
  lockEl?.addEventListener("dblclick", dismissLock);

  const onMobileChange = () => {
    if (mobileMq.matches) {
      closeOutfitChecker();
      showLock();
    }
    else {
      if (lockEl) lockEl.hidden = true;
      document.body.classList.remove("ftw-locked");
      stopLockWalls();
    }
  };

  document.addEventListener("visibilitychange", () => {
    if (document.hidden) {
      if (lockWallTimer) {
        clearTimeout(lockWallTimer);
        lockWallTimer = null;
      }
      return;
    }
    if (lockEl && !lockEl.hidden) armLockWalls();
  });

  if (mobileMq.addEventListener) mobileMq.addEventListener("change", onMobileChange);
  else mobileMq.addListener?.(onMobileChange);

  showLock();
  if (/\/cart\/?$/.test(location.pathname)) openDrawer("ftw-bag");
  const landingHandle = root.dataset.ftwProduct || productHandleFromPath();
  if (landingHandle) {
    const landingCard = cardForHandle(landingHandle);
    if (landingCard) openSheet(landingCard);
  }

  window.addEventListener("popstate", () => {
    sheetHistoryPending = false;
    const handle = productHandleFromPath();
    if (!handle) {
      if (!$("#ftw-sheet")?.hidden) closeSheet(true, true);
      return;
    }
    const card = cardForHandle(handle);
    if (card) openSheet(card);
    else if (!$("#ftw-sheet")?.hidden) closeSheet(true, true);
  });

  fitProductImages();
  const sheetStage = $("#ftw-sheet-stack");
  let sheetPointer = null;
  let sheetSuppressClick = false;

  sheetStage?.addEventListener("pointerdown", (e) => {
    if (!sheetSlidesSideways()) return;
    if (e.button != null && e.button !== 0) return;
    if (e.target.closest(".ftw-sheet__dot")) return;
    const reel = sheetStage.querySelector(".ftw-sheet__reel");
    const count = $$(".ftw-sheet__shot", sheetStage).length;
    if (!reel || count < 2) return;
    sheetPointer = {
      id: e.pointerId,
      x: e.clientX,
      index: sheetImageIndex,
      width: reel.clientWidth || sheetStage.clientWidth,
    };
    reel.style.transition = "none";
    sheetStage.setPointerCapture?.(e.pointerId);
  });

  sheetStage?.addEventListener("pointermove", (e) => {
    if (!sheetPointer || e.pointerId !== sheetPointer.id) return;
    const dx = e.clientX - sheetPointer.x;
    if (Math.abs(dx) < 4) return;
    const reel = sheetStage.querySelector(".ftw-sheet__reel");
    const count = $$(".ftw-sheet__shot", sheetStage).length;
    if (!reel) return;
    sheetPointer.dragged = true;
    sheetStage.classList.add("is-dragging");
    const base = -sheetPointer.index * sheetPointer.width;
    const min = -(count - 1) * sheetPointer.width;
    const x = Math.max(min - 36, Math.min(36, base + dx));
    reel.style.transform = `translate3d(${x}px, 0, 0)`;
  });

  function endSheetDrag(e) {
    if (!sheetPointer || (e && e.pointerId !== sheetPointer.id)) return;
    const dx = e ? e.clientX - sheetPointer.x : 0;
    const dragged = sheetPointer.dragged;
    const index = sheetPointer.index;
    sheetPointer = null;
    sheetStage.classList.remove("is-dragging");
    if (!dragged) return;
    sheetSuppressClick = true;
    if (dx <= -48) moveSheet(index + 1);
    else if (dx >= 48) moveSheet(index - 1);
    else moveSheet(index);
  }

  sheetStage?.addEventListener("pointerup", endSheetDrag);
  sheetStage?.addEventListener("pointercancel", endSheetDrag);
  sheetStage?.addEventListener("click", (e) => {
    if (sheetSuppressClick) {
      sheetSuppressClick = false;
      e.preventDefault();
      return;
    }
    const dot = e.target.closest("[data-ftw-shot]");
    if (!dot) return;
    moveSheet(Number(dot.dataset.ftwShot));
  });

  function sheetStageFrame() {
    const layout = $(".ftw-sheet__layout");
    const stage = $("#ftw-sheet-stack");
    if (!layout || !stage || window.innerWidth > 900) return null;
    const collapsed = Math.max(280, Math.round(layout.clientWidth * 0.7));
    const expanded = Math.round(Math.min(layout.clientHeight * 0.74, collapsed + 170));
    if (!layout.clientHeight) return null;
    return { layout, stage, collapsed, expanded: Math.max(collapsed, expanded) };
  }

  let sheetStageFramePending = 0;

  function applySheetStage(expand) {
    const frame = sheetStageFrame();
    const stage = $("#ftw-sheet-stack");
    if (!frame || !stage) {
      if (stage) stage.style.height = "";
      return;
    }
    const current = stage.getBoundingClientRect().height;
    const next = expand ? frame.expanded : Math.min(frame.expanded, Math.max(frame.collapsed, current));
    stage.style.height = `${Math.round(next)}px`;
    if (sheetStageFramePending) return;
    sheetStageFramePending = requestAnimationFrame(() => {
      sheetStageFramePending = 0;
      fitSheetImages();
    });
  }

  window.addEventListener("resize", () => {
    fitProductImages();
    if (sheetOpen) {
      moveSheet(sheetImageIndex, false);
      applySheetStage(false);
      fitSheetImages();
    }
  });
})();
